import { useQuery } from '@tanstack/react-query'

import { getFreeeCompanies } from '@src/api'
import { DefaultApiGetFreeeCompaniesRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchFreeeCompanies = ({
  organizationId,
}: DefaultApiGetFreeeCompaniesRequest) => {
  const { axiosInstance } = useAxios()
  const { data, isError, isLoading } = useQuery({
    enabled: !!organizationId,
    queryFn: () => getFreeeCompanies(axiosInstance, { organizationId }),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_FREEE_COMPANIES],
  })

  return { data, isError, isLoading }
}
